import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paper: {
        borderRadius: 12,
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.08)",
        backgroundColor: "#fff",
        textAlign: "center",
        padding: "80px 0px",
        width: 650,
        outline: 'none',
        zIndex: 1800,
        [theme.breakpoints.down('md')]: {
            padding: "69px 64px 74px",
        },
    },
    panel: {
        "& p": {
            fontSize: 16,
            margin: 0,
            [theme.breakpoints.down('md')]: {
                fontSize: 12,
                width: "auto",
            },
        },
    },
    modalHeader: {
        marginBottom: 9,
        fontWeight: 500,
        [theme.breakpoints.down('md')]: {
            width: "auto",
        },
    },
    buttonSection: {
        marginTop: 50
    },
    cancelButton: {
        width: 190,
        marginRight: 20,
        color: "#2D91E9",
        border: "1px solid #E8E8E8",
        background: "#FFF",
        zIndex: 1,
        "&:hover": {
            background: "#FFF",
            border: "1px solid #2D91E9",
        },
        [theme.breakpoints.down('md')]: {
            marginRight: 0,
        },
    },
    confirmButton: {
        width: 190,
        zIndex: 1
    }
});